import { Box, Button, IconButton, ListItemIcon, Menu, MenuItem, Typography } from '@mui/material'
import { FC, MouseEventHandler, useState } from 'react'
import ArrowSmallIcon from '../../assets/icons/ArrowSmall.svg?react'
import ArrowUpIcon from '../../assets/icons/ArrowUp.svg'
import CalendarArrowUpIcon from '../../assets/icons/CalendarArrowUp.svg?react'

type Props = {
    hasAudio: boolean
    disabled?: boolean
    isTempUser: boolean
    handleOpenRegularRequestCreateDialog: VoidFunction
}

export const SubmitButton: FC<Props> = ({
    disabled,
    hasAudio,
    isTempUser,
    handleOpenRegularRequestCreateDialog,
}) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

    const handleOpenMenu: MouseEventHandler<HTMLButtonElement> = (event) => {
        const { currentTarget } = event
        event.preventDefault()

        // нужно время чтобы закрыть виртуальную клавиатуру на мобильных устройствах
        setTimeout(() => {
            setAnchorEl(currentTarget)
        }, 300)
    }

    const handleCloseMenu = () => {
        setAnchorEl(null)
    }

    const handleCreateRegularRequest = () => {
        handleOpenRegularRequestCreateDialog()
        handleCloseMenu()
    }

    const open = Boolean(anchorEl)

    if (hasAudio || isTempUser) {
        return (
            <IconButton
                id="request-box_submit"
                size="large"
                color="primary"
                type="submit"
                disabled={disabled}
                sx={{
                    marginLeft: 'auto',
                    backgroundColor: (theme) => theme.palette.primary.main,
                }}>
                <ArrowUpIcon />
            </IconButton>
        )
    }

    return (
        <>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleCloseMenu}
                slotProps={{
                    paper: {
                        elevation: 0,
                    },
                    list: {
                        sx: {
                            p: '4px',
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'top' }}>
                <MenuItem
                    onClick={handleCreateRegularRequest}
                    sx={{
                        p: '10px 12px',
                    }}>
                    <ListItemIcon
                        sx={{
                            justifyContent: 'flex-start',
                            '&&': {
                                minWidth: '28px',
                            },
                        }}>
                        <CalendarArrowUpIcon color="#006CFD" />
                    </ListItemIcon>
                    <Typography variant="body2">Добавить в регулярные запросы</Typography>
                </MenuItem>
            </Menu>

            <Button
                id="request-box_submit"
                type="submit"
                sx={{
                    p: 0,
                    gap: '3px',
                    ml: 'auto',
                }}
                variant="contained">
                <Box
                    sx={{
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        p: '5px',
                        width: '40px',
                        height: '40px',

                        '&:after': {
                            position: 'absolute',
                            right: '-1px',
                            content: "' '",
                            width: '1px',
                            height: '50%',
                            backgroundColor: '#6EACFF',
                        },
                    }}>
                    <ArrowUpIcon />
                </Box>
                <IconButton
                    id="request-box_more_actions"
                    size="small"
                    disabled={disabled}
                    onClick={handleOpenMenu}
                    sx={{
                        width: '40px',
                        height: '40px',
                        color: '#FFFFFF',
                        ':hover': {
                            backgroundColor: '#217DF8',
                        },
                    }}>
                    <ArrowSmallIcon width={12} height={12} />
                </IconButton>
            </Button>
        </>
    )
}
